import { COLORS } from "./colors";

export const LIGHT_BORDER = `1px solid ${COLORS.LIGHT}`;
export const BASE_Z_INDEX = 1000;
export const BULK_ASSET_TABLE_DIALOG_Z_INDEX = BASE_Z_INDEX;
export const ISSUES_DRAWER_Z_INDEX = BASE_Z_INDEX + 1;
export const FLYOUT_Z_INDEX = BASE_Z_INDEX + 2;
// MUI badge components default to max of 99 if an explicit max is not provided. This constant sets a higher max to effectively remove the max.
export const MUI_BADGE_MAX_COUNT = 1_000_000;
